/**
 * Strings of the visual overhaul's WP2 (conversation)
 * (docs/design/visual-overhaul.md §11). Merged into the catalogue after
 * every other table, so a key here may override an older one. The copy is
 * ours (§3.1): the history bars say "Showing older messages" / "Back to
 * latest ↓" and "{n} new since {time}" / "Mark read"; the edit hint is
 * "Esc cancels · Enter saves".
 */
import type { Dict } from '../core';

export const chatEn: Dict = {
  // history bars and dividers (§7.12)
  'ns.hist.older': 'Showing older messages',
  'ns.hist.jumpPresent': 'Back to latest ↓',
  'chat.new.tag': 'NEW',
  'chat.new.label': 'New messages',
  'chat.new.count': { one: '{n} new since {time}', other: '{n} new since {time}' },
  'chat.new.countMore': { one: '{n}+ new since {time}', other: '{n}+ new since {time}' },
  'chat.new.markRead': 'Mark read',
  // the inline edit hint (P5): the key names are links
  'chat.edit.esc': 'Esc',
  'chat.edit.cancels': 'cancels',
  'chat.edit.enter': 'Enter',
  'chat.edit.saves': 'saves',
  'ns.msg.editHint': 'Esc cancels · Enter saves',
  // the reply bar's ping toggle (P24)
  'chat.reply.on': 'ON',
  'chat.reply.off': 'OFF',
  'chat.reply.pingOn': 'Mention on: they get a notification',
  'chat.reply.pingOff': 'Mention off: no notification',
  // code blocks (P2)
  'chat.code.copy': 'Copy',
  'chat.code.plain': 'Text',
  'chat.code.preview': '[code]',
  // search and pins in the slot (§7.26)
  'chat.search.title': 'Search results',
  'chat.search.clear': 'Clear search',
  'chat.search.filters': 'Filter by person, channel or what a message has',
  'chat.jump': 'Jump',
  // the lightbox (I26)
  'chat.lb.original': 'Open original',
  'chat.lb.prev': 'Previous image',
  'chat.lb.next': 'Next image',
  // the emoji picker's categories
  'chat.emoji.categories': 'Emoji categories',
  'chat.emoji.people': 'Smileys & people',
  'chat.emoji.nature': 'Animals & nature',
  'chat.emoji.activities': 'Activities',
  'chat.emoji.travel': 'Travel & places',
  'chat.emoji.objects': 'Objects',
  'chat.emoji.symbols': 'Symbols',
  'chat.emoji.flags': 'Flags',
};
